import "./apple-sign-in_large--black.scss"
import "./apple-sign-in_large--white.scss"
import "./apple-sign-up_large--white.scss"

// console.log('Apple Sign In buttons loaded')

function initAppleSignIn() {
  // console.log('Initializing Apple Sign In...')

  // Get configuration from data attributes on the Apple button
  const appleButton = document.getElementById("custom-apple-signin")
  if (!appleButton) {
    // console.log('Apple Sign In button not found.')
    return
  }

  const clientId = appleButton.getAttribute("data-client-id")
  const redirectURI = appleButton.getAttribute("data-redirect-uri")
  const state = appleButton.getAttribute("data-state")
  const nonce = appleButton.getAttribute("data-nonce")

  // if (!clientId) {
  //   console.error('Missing client ID for Apple Sign In.')
  //   return
  // }

  // if (!redirectURI) {
  //   console.error('Missing redirect URI for Apple Sign In.')
  //   return
  // }

  // if (!state) {
  //   console.error('Missing state for Apple Sign In.')
  //   return
  // }

  // if (!nonce) {
  //   console.error('Missing nonce for Apple Sign In.')
  //   return
  // }

  // Initialize Apple Sign In
  const appleAuth = (window as any).AppleID.auth

  appleAuth.init({
    clientId,
    scope: "name email",
    redirectURI,
    state,
    nonce,
    usePopup: true,
  })

  // Connect custom button to official button
  appleButton.addEventListener("click", (e) => {
    // console.log('Custom Apple Sign In button clicked.')
    e.preventDefault()
    const appleSignInButton = document.querySelector("#appleid-signin")
    if (appleSignInButton instanceof HTMLElement) {
      appleSignInButton.click()
    }
  })
}

// Initialize Apple Sign In functionality
function setupAppleSignIn() {
  // console.log('Setting up Apple Sign In...')

  // Load Apple's JS library if needed
  if (typeof (window as any).AppleID === "undefined") {
    const script = document.createElement("script")
    script.type = "text/javascript"
    script.src =
      "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js"
    script.onload = initAppleSignIn
    document.head.appendChild(script)
  } else {
    initAppleSignIn()
  }

  // Listen for authorization success
  document.addEventListener("AppleIDSignInOnSuccess", (event) => {
    // console.log('Apple Sign In Success:', (event as any).detail)

    fetch("/auth/apple/handle_success", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token":
          document.querySelector('meta[name="csrf-token"]')?.getAttribute("content") || "",
      },
      body: JSON.stringify({ data: (event as any).detail }),
    })
      .then((response) => {
        if (response.ok) {
          // console.log('Successfully authenticated with Apple.')
          window.location.href = "/my"
        } else {
          response.json().then((data) => {
            // console.error('Apple Sign In failed on server:', data.message || response.statusText)
            // eslint-disable-next-line no-alert
            alert(`Sign in with Apple failed: ${data.message || "Please try again."}`)
          })
        }
      })
      .catch((error) => {
        // console.error('Error sending Apple sign in data to server:', error)
        // eslint-disable-next-line no-alert
        alert(`An error occurred during sign in. Please try again., error: ${error.message}`)
      })
  })

  // Listen for authorization failures
  document.addEventListener("AppleIDSignInOnFailure", (event) => {
    // eslint-disable-next-line no-console
    console.error("Apple Sign In Failure:", (event as any).detail.error)
  })
}

// Try multiple ways to ensure our setup code runs
if (document.readyState === "loading") {
  // Document still loading, add event listener
  document.addEventListener("DOMContentLoaded", setupAppleSignIn)
} else {
  // DOMContentLoaded has already fired
  setupAppleSignIn()
}
